/* eslint-disable import/no-named-as-default */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { spring } from 'react-motion';
import withStyles from 'isomorphic-style-loader/withStyles'
import smoothscroll from 'smoothscroll-polyfill';
import _ from 'lodash';
import classNames from 'classnames';

import { ApplyDefault, ApplyMobile } from '../../utils/mediaQueries';
import { elementIsInView } from '../../utils/helpers';
import { getStudentWaitlists, saveAdditionalQuestionsAnswers } from '../../actions/student';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import School from '../../components/School';
import Star from '../../components/icons/Star';
import SchoolEvents from '../../components/SchoolEvents';
import StatusCard from '../../components/StatusCard';
import AlertModal from '../../components/AlertModal';
import { getSavedProgramCards, handleOfferDecision, getWaitlistsSubmissionsState } from '../../actions/schools';
import localMessages from './localMessages';
import messages from '../../locale/messages';
import style from './Waitlist.scss';
import { withRtl } from '../../components/hoc';
import WaitlistCard from '../../components/WaitlistCard';
import { joinWaitlist, removeFromWaitlist } from '../../actions/joinWaitlist';
import AutocompleteField from '../../components/AutocompleteField/AutocompleteField';
import { getSavedProgramsAutocomplete } from '../../actions/autocomplete';
import { saveProgram } from '../../actions/saveProgram';
import { addNewSchoolWaitlist } from '../../actions/saveApplication';
import Tooltip from '../../components/Tooltip';
import QuestionsPopUp from '../../components/QuestionsPopUp';
import SRQuestionsPopUp from '../../components/SRQuestionsPopUp';
import { isMS, isSR, customisedIntlFormatMessage } from '../../utils/helpers';



const WAITLISTS = 'WAITLISTS';
const PROGRAMS = 'PROGRAMS';

class Waitlist extends Component {
  static propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape).isRequired,
    loading: PropTypes.bool.isRequired,
    schools: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ).isRequired,
    normalWaitlistSchools: PropTypes.shape({
      entities: PropTypes.shape({
        school: PropTypes.shape([]),
      }),
    }),
    user: PropTypes.shape({
      applicationId: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      studentWaitlists: PropTypes.shape(),
      firstName: PropTypes.string.isRequired,
      studentInfo: PropTypes.shape({
        // first_name: PropTypes.string,
      }),
      admissionProcess: PropTypes.string.isRequired,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    isRtl: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
  };

  static contextTypes = {
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    normalWaitlistSchools: null,
    isRtl: false,
  };

  constructor(props) {
    super(props);

    // used to remember which destination was hovered last,
    // so the state is changed only when the first hover is triggered
    this.lastHoverIndex = null;
    this.state = {
      currentSchoolDetail: null,
      currentProgramId: 0,
      applicationLightBox: false,
      // applicationPopUp: false,
      mobileRender: WAITLISTS,
      sortBy: 'savedAt',
      sortByDirection: 'highToLow',
      loaded: false,
      showRemoveWaitlistAlertModal: false,
      waitlistId: 0,
      programId: 0,
      schoolName: [],
      showAcceptWaitlistAlertModal: false,
      showDeclineWaitlistAlertModal: false,
      show2KAcceptWarningModal: false,
      pendingAcceptPayload: null,
      showQuestions: false,
      showSRQuestions: false,
      isEdit: false,
      processingWaitlist: 0
    };

    this.mobileRenderMapping = {
      WAITLISTS: this.renderWaitlists,
      PROGRAMS: this.renderPrograms,
    };

    smoothscroll.polyfill();
  }

  componentDidMount() {
    const { user, dispatch, acceptedAndDeclinedOffers } = this.props;
    const { applicationId } = user;
    const { loaded } = this.state;
    if (loaded) {
      return;
    }

    const getStudentWaitlistsTask = dispatch(getStudentWaitlists(applicationId)).catch((error) => {
      console.error('Failed to getStudentWaitlists', error);
    });
    const getSchoolsProgramsTask = dispatch(getSavedProgramCards()).catch((error) => {
      console.error('Failed to getSavedPrograms', error);
    });
    const getWaitlistsSubmissionState = dispatch(getWaitlistsSubmissionsState()).catch((error) => {
      console.error('Failed to getWaitlistsSubmissionState', error);
    });

    Promise.all([getStudentWaitlistsTask, getSchoolsProgramsTask, getWaitlistsSubmissionState])
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
        });
      })
      .catch((error) => {
        console.error('Error', error);
      });
  }

  backToList = () => {
    this.setState({
      currentSchoolDetail: null,
      currentProgramId: 0,
    });
  };

  handleSchoolClick = (id, event) => {
    // someone just selected the button via keyboard
    if (event && event.type === 'keydown') {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
    }

    const { currentSchoolDetail, currentProgramId } = this.state;
    if (currentSchoolDetail === id) {
      // CURRENT SCHOOL
      if (currentProgramId) {
        // clicking a school map title AND we have a program open
        this.setState({
          ...this.state,
          currentProgramId: 0,
        });
      } else {
        // clicking the school map title when school card is open and no program is open
        this.setState({
          ...this.state,
          currentSchoolDetail: id,
          currentProgramId: 1,
        });
      }
    } else {
      this.setState({
        ...this.state,
        currentSchoolDetail: id,
        currentProgramId: 0,
      });
    }

    // need to scroll this so the school details are actually visible
    const target = document.querySelector('.backToListScrollTarget');
    if (target && !elementIsInView(target)) {
      const scrollY = window.pageYOffset + target.getBoundingClientRect().bottom;
      // sk - math is as follows
      // 62 = nav bar height
      // 66 = back to button height
      // 20 = padding so the button isn't flush with the nav bar
      window.scrollTo(0, scrollY - (62 + 66 + 20));
    }
  };

  handleProgramClick = (id, schoolId) => {
    const { currentProgramId } = this.state;
    // sk: if we are in school detail
    // all user interactions are intentional
    if (id === currentProgramId) {
      this.setState({
        ...this.state,
        currentProgramId: 1,
      });
    } else {
      this.setState({
        ...this.state,
        currentSchoolDetail: schoolId,
        currentProgramId: id,
      });
    }
  };

  willEnter = () => ({
    maxWidth: 0,
    maxHeight: 0,
    opacity: 0,
    // translateX: 0,
  });

  willLeave = () => ({
    maxWidth: spring(0),
    maxHeight: spring(0),
    opacity: spring(0),
    // translateX: spring(640),
  });

  renderPrograms = () => {
    const {
      acceptedAndDeclinedOffers,
      pendingWaitlistOffers,
      normalSchools,
      user,
      user: { applicationId },
      intl,
      isRtl,
      canAddRemoveWaitlist,
      canEditWaitlistOfferResponse,
      canAddProgramToWaitlist,
      showFavoriteProgramsSection
    } = this.props;

    // It is coming from admission process to allow decline button for accepted offers
    const { isRejectAcceptedOfferAllowed } = user;

    return (
      <>
        <div className={style.sidebarHeader} data-coachmark="apply-step-1">
          <Star fill="#4EE4B3" size="32px" />
          <FormattedMessage {...localMessages.waitlistOffersHeader} tagName="h2" />
        </div>
        <div className={style.offersContainer}>
          {acceptedAndDeclinedOffers.length ? (
            acceptedAndDeclinedOffers.map((offer) => offer && (
              <StatusCard
                key={offer.id}
                headerTitle={offer.directory_program.directory_school_name}
                subheaderTitle={offer.directory_program.name}
                offerStatus={offer.offer_response}
                statusOnClick={this.handleStatusClick}
                programId={offer.directory_program.id}
                waitlistId={offer.id}
                schoolId={offer.directory_program.directory_school_id}
                supplimentalLinkText={customisedIntlFormatMessage(intl, localMessages.waitlistSupplimentalLinkText)}
                isSR={user.isSR}
                showSRQuestionsPopUp={this.showSRQuestionsPopUp}
                isRejectAcceptedOfferAllowed={isRejectAcceptedOfferAllowed}
                canAddProgramToWaitlist={canAddProgramToWaitlist}
                canAddRemoveWaitlist={canAddRemoveWaitlist}
                onRejoinWaitlist={(programId, schoolId, offerRejoin) => {
                    offerRejoin['processingRejoin'] = true; // Mark this offer as under process
                    this.addToWaitlist({ programId, schoolId });
                  }
                }
                offer={offer}
                infoCard
              />
            ))
          ) : (
            <p className={style.sidebarSubheader}>
              <FormattedMessage
                defaultMessage="Looks like you have not accepted or declined any offers."
                id="waitlist.NoCurrentOffers"
              />
            </p>
          )}
        </div>
        <div className={style.sidebarHeader} data-coachmark="apply-step-1">
          <Star fill="#4EE4B3" size="32px" />
          <FormattedMessage {...localMessages.waitlistPendingOffersHeader} tagName="h2" />
        </div>
        {pendingWaitlistOffers.length ? (
          pendingWaitlistOffers.map((offer) => (
            <StatusCard
              key={offer.id}
              headerTitle={offer.directory_program.directory_school_name}
              subheaderTitle={offer.directory_program.name}
              statusOnClick={this.handleStatusClick}
              infoCard={offer.is_shs_discovery_offer}
              programId={offer.directory_program.id}
              waitlistId={offer.id}
              deadlineDate={offer.offer_response_deadline}
              disabled={!canEditWaitlistOfferResponse}
              isSHSDiscoveryOffer={offer.is_shs_discovery_offer}
              supplimentalLinkText={''}
              isRejectAcceptedOfferAllowed={isRejectAcceptedOfferAllowed}
              isSR={user.isSR}
              offer={offer}
            />
          ))
        ) : (
          <p className={style.sidebarSubheader}>
            <FormattedMessage defaultMessage="You don't have any offers." id="waitlist.NoWaitlistOffers" />
          </p>
        )}
        {showFavoriteProgramsSection &&
        <div className={style.sidebarHeader} data-coachmark="apply-step-1">
          <Star fill="#4EE4B3" size="32px" />
          <FormattedMessage {...messages.generalStringSavedPrograms} tagName="h2" />
        </div>
        }
        {showFavoriteProgramsSection && normalSchools.result.map((schoolID) => {
          const {
            programs: { result: programIDs },
            url,
          } = normalSchools.entities.school[schoolID];
          return programIDs.map((programID) => {
            const programData = normalSchools.entities.school[schoolID].getProgram(programID);
            let school_dbn = normalSchools.entities.school[schoolID]['school_dbn'];
            if (!school_dbn) {
              school_dbn = normalSchools.entities.school[schoolID]['school']['dbn'];
            }
            const { admission_process: admissionProcess } = programData;
            if (programData.saved) {
              return (
                <div className={style.listApplyItem} key={programID}>
                  <div className={style.school}>
                    <h4 className={style.schoolName}>
                      <a href={`/dashboard/${applicationId}${url}`} target="_blank" rel="noopener">
                        {programData.directory_school_name}
                      </a>
                    </h4>
                    <p className={style.programName}>{programData.name}</p>
                    {!user.isSR && (
                      <SchoolEvents
                        page={'waitlist'}
                        dbn={school_dbn}
                      />
                    )}
                  </div>
                  <div className={style.button}>
                    {user.studentWaitlists.results.includes(programID) ? (canAddProgramToWaitlist ? (
                      <Button
                        ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                          savedProgram: programData.name,
                          programSchool: programData.directory_school_name,
                        })}
                        label="Added!"
                        attachLeft={!isRtl}
                        attachRight={isRtl}
                        iconTop="Check"
                        customClass={style.addedButton}
                        iconColor="#052b52"
                        onClick={()=> {}}
                        disabled
                      />
                    ) :
                      <div className={style.tooltipContainer}>
                        <Tooltip
                          icon={<i className="icon-Alert" />}
                          left={-250}
                          width="250px"
                          top="50%"
                          ariaLabel={customisedIntlFormatMessage(intl, localMessages.cannotApplySubmissionsClosed, {
                            firstName: user.firstName,
                          })}
                        >
                          <FormattedMessage
                            {...localMessages.cannotApplySubmissionsClosed}
                            values={{
                              admissionProcess: admissionProcess,
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : admissionProcess === 'Specialized High School' ? (
                      <div className={style.tooltipContainer}>
                        <Tooltip
                          icon={<i className="icon-Alert" />}
                          left={-250}
                          width="250px"
                          top="50%"
                          ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringStudentNotEligible, {
                            firstName: user.firstName,
                          })}
                        >
                          <FormattedMessage
                            {...messages.generalStringProgramHasDifferentAdmissionProcess}
                            values={{
                              admissionProcess: admissionProcess,
                            }}
                          />
                        </Tooltip>
                      </div>
                    ) : (canAddProgramToWaitlist ? (
                      <Button
                        ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                          savedProgram: programData.name,
                          programSchool: programData.directory_school_name,
                        })}
                        label={customisedIntlFormatMessage(intl, messages.buttonAdd)}
                        onClick={canAddRemoveWaitlist ? (
                          () =>
                            this.addToWaitlist({
                              programId: programID,
                              schoolId: schoolID,
                              savedApplication: false,
                              savedApplicationId: '',
                              programData,
                            })
                        ) : (() => { })
                        }
                        attachLeft={!isRtl}
                        attachRight={isRtl}
                        iconTop="Plus"
                        disabled={!canAddRemoveWaitlist}
                      />
                    ) : <div className={style.tooltipContainer}>
                      <Tooltip
                        icon={<i className="icon-Alert" />}
                        left={-250}
                        width="250px"
                        top="50%"
                        ariaLabel={customisedIntlFormatMessage(intl, localMessages.cannotApplySubmissionsClosed, {
                          firstName: user.firstName,
                        })}
                      >
                        <FormattedMessage
                          {...localMessages.cannotApplySubmissionsClosed}
                          values={{
                            admissionProcess: admissionProcess,
                          }}
                        />
                      </Tooltip>
                    </div>)}
                  </div>
                </div>
              );
            }
            return null;
          });
        })}
      </>
    );
  };

  mobileShowWaitlists = () => {
    this.setState({ mobileRender: WAITLISTS });
  };

  mobileShowPrograms = () => {
    this.setState({ mobileRender: PROGRAMS });
  };

  renderMobileButtons = () => {
    const { intl } = this.props;
    const { mobileRender } = this.state;
    const programClasses = ['button--no-style', style.programsButton];
    const applicationClasses = ['button--no-style', style.applicationButton];

    if (mobileRender === PROGRAMS) {
      programClasses.push(style.mainButtonsActive);
    } else if (mobileRender === WAITLISTS) {
      applicationClasses.push(style.mainButtonsActive);
    }
    return (
      <ApplyMobile>
        <div className={style.mainButtonsWaitlist} data-coachmark="apply-mobile-step-1">
          <button
            className={classNames(...applicationClasses)}
            aria-label={customisedIntlFormatMessage(intl, localMessages.applyApplicationButton)}
            onClick={this.mobileShowWaitlists}
          >
            <i className="icon-Time" /> Your Waitlists
          </button>
          <button
            className={classNames(...programClasses)}
            aria-label={customisedIntlFormatMessage(intl, messages.generalStringSavedPrograms)}
            onClick={this.mobileShowPrograms}
          >
            <i className="icon-Star" /> Your programs
          </button>
        </div>
      </ApplyMobile>
    );
  };

  showAlertModal = (schoolName, programId, waitlistId, modalToShow) => {
    this.setState({ ...this.state, [modalToShow]: true, waitlistId, programId, schoolName });
  };

  hideAlertModal = (modalToHide) => {
    this.setState({ ...this.state, [modalToHide]: false, waitlistId: 0, programId: 0 });
  };

  show2KAcceptWarningModal = (payload) => {
    this.setState({ ...this.state, show2KAcceptWarningModal: true, pendingAcceptPayload: payload, programId: payload.programId, waitlistId: payload.waitlistId });
  };

  hide2KAcceptWarningModal = () => {
    this.setState({ ...this.state, show2KAcceptWarningModal: false, pendingAcceptPayload: null, programId: 0, waitlistId: 0 });
  };

  handle2KAcceptWarningConfirm = () => {
    this.handleOfferStatusUpdate(true);
    this.hide2KAcceptWarningModal();
  };

  handleRemoveWaitlistCard = () => {
    const { programId, waitlistId } = this.state;
    this.props.removeFromWaitlist(programId, waitlistId);
    this.hideAlertModal('showRemoveWaitlistAlertModal');
  };

  handleStatusClick = (schoolName, programName, programId, waitlistId, accepted, warningMessage = '') => {
    const { acceptedAndDeclinedOffers, pendingWaitlistOffers, user } = this.props;
    if (accepted && warningMessage) {
      this.show2KAcceptWarningModal({ schoolName, programName, programId, waitlistId, warningMessage });
      return;
    }
    if (accepted) {
      const acceptedOffers = acceptedAndDeclinedOffers.filter((offer) => offer.offer_response === 'AC');
      const acceptedSchools = acceptedOffers.map(
        ({ directory_program: { directory_school_name, name } }) => `${directory_school_name}'s ${name}`,
      );
      const schoolPrograms = pendingWaitlistOffers.filter((offer) => offer.id !== waitlistId && !offer.is_shs_discovery_offer && (offer.is_main_offer || (!offer.is_main_offer && offer.offer_response === 'AC')));
      const schoolDescription = schoolPrograms.map(
        ({ directory_program: { directory_school_name, name } }) => `${directory_school_name}'s ${name}`,
      );

      if (schoolPrograms.length != 0 || acceptedSchools.length != 0 || user.dr_sr_offer) {
        let modal_data = [...schoolDescription, ...acceptedSchools];
        if(user.dr_sr_offer){
          modal_data.push(user.dr_sr_offer)
        }
        this.showAlertModal(
          modal_data,
          programId,
          waitlistId,
          'showAcceptWaitlistAlertModal',
        );
      } else {
        if (isSR({ user })){
          this.showSRQuestionsPopUp(waitlistId, programId, this.state.isEdit)
          return false;
        }else{
          this.props.handleOfferDecision(programId, waitlistId, accepted);
        }
      }

    } else {
      const schoolDescription = [`${schoolName}'s ${programName}`];
      this.showAlertModal(schoolDescription, programId, waitlistId, 'showDeclineWaitlistAlertModal');
    }
  };

  handleOfferStatusUpdate = (accepted) => {
    const { programId, waitlistId } = this.state;
    const { user } = this.props;
    if (accepted) {
      this.hideAlertModal('showAcceptWaitlistAlertModal');
    } else {
      this.hideAlertModal('showDeclineWaitlistAlertModal');
    }
    if (isSR({ user }) && accepted){ // show only when offer is being accepted
      this.showSRQuestionsPopUp(waitlistId, programId, this.state.isEdit)
      return false;
    }else{
      this.props.handleOfferDecision(programId, waitlistId, accepted);
    }
  };

  handleKeyDown = (event, value = null) => {
    const { dispatch } = this.props;
    const searchProgramsValue = value !== null ? value : event.target.value;
    const excludeSHS = true;
    this.setState({
      ...this.state,
      searchProgramsValue,
    });

    dispatch(getSavedProgramsAutocomplete(searchProgramsValue, excludeSHS));
  };

  calculateIsWaitlistJoinable(programId, studentWaitlists, acceptedAndDeclinedOffers, pendingWaitlistOffers) {
    // Students can re-join waitlists if their offer response is DE (Declined) or NR (No Response)
    // This function determines if a student is eligible to re-join a given program's waitlist
    const waitlistRecord = (studentWaitlists.entities.waitlists && studentWaitlists.entities.waitlists[programId]) || {};
    const hasExistingRecord = !!waitlistRecord.id;
    const lockedOffer = hasExistingRecord && ['AC', 'PE', 'OO'].includes(waitlistRecord.offer_response);

    const combinedOffers = [
      ...(acceptedAndDeclinedOffers || []),
      ...(pendingWaitlistOffers || [])
    ];
    const matchingOffer = combinedOffers.find(
      offer =>
        offer.directory_program &&
        offer.directory_program.id === programId &&
        ['AC', 'PE', 'OO'].includes(offer.offer_response)
    );

    return hasExistingRecord ? !lockedOffer : !matchingOffer;
  }

  handleSaveApplication = (id, schoolId, schoolDbn, savedApplication, savedApplicationId) => {
    const { showPopupContent, dispatch, user, acceptedAndDeclinedOffers, pendingWaitlistOffers } = this.props;

    const isWaitlistJoinable = this.calculateIsWaitlistJoinable(
      id,
      user.studentWaitlists,
      acceptedAndDeclinedOffers,
      pendingWaitlistOffers
    );

    if (!isWaitlistJoinable) {
      return false;
    }

    // const programHasNotBeenFavorited = !_.includes(normalSchools.result, schoolId);
    // if (programHasNotBeenFavorited) {

    dispatch(addNewSchoolWaitlist(id, schoolId, schoolDbn, savedApplication, savedApplicationId, isWaitlistJoinable));
    // showPopupContent(`Program added to you application.  We've also saved it for you.`, this.pageX, this.pageY);
    // showPopupContent({
    //   children: `Program added to you application. We've also saved it for you.`,
    //   // top: this.pageX,
    //   // left: this.pageY,
    // });
    return true;
    // }
    // dispatch(joinWaitlist(id, schoolId, savedApplication, savedApplicationId));
    // return true;
  };

  showQuestionsPopUp = (waitlistId) => {
    this.setState({ ...this.state, showQuestions: true, waitlistId });
  };

  hideQuestionsPopUp = () => {
    this.setState({ ...this.state, showQuestions: false, waitlistId: 0 });
  };

  showSRQuestionsPopUp = (waitlistId, programId, isEdit) => {
    this.setState({ ...this.state, showSRQuestions: true, isEdit: isEdit, waitlistId, programId });
  };

  hideSRQuestionsPopUp = () => {
    this.setState({ ...this.state, showSRQuestions: false, isEdit: false, waitlistId: 0, showAcceptWaitlistAlertModal: false });
  };

  renderSchools = () => {
    const {
      user: {
        studentWaitlists: {
          entities: { waitlists: waitlistData },
          results: waitlistIDs,
        },
      },
      pendingWaitlistPrograms,
      loading,
      user,
      schools,
      canAddRemoveWaitlist,
      showWaitlistPriorityGroupAndPosition,
    } = this.props;
    const { firstName, admissionProcess } = user;
    const { currentSchoolDetail, currentProgramId } = this.state;
    let load = null;

    if (loading) {
      load = (
        <ul className={style.list}>
          <li className={style.listItem}>
            <Loader />
          </li>
        </ul>
      );
      return load;
    }

    if (currentSchoolDetail !== null) {
      return (
        <ul className={style.list}>
          <li key="detail" className={style.listItem}>
            <School
              {..._.find(schools, { id: currentSchoolDetail })}
              loggedIn
              showDetails
              headerOpen={!currentProgramId}
              onClick={this.handleSchoolClick}
              programClick={this.handleProgramClick}
              programOpen={currentProgramId}
              user={user}
              firstName={firstName}
              headerHeadingTagName="h3"
              admissionProcess={admissionProcess}
            />
          </li>
        </ul>
      );
    }

    let programsSortedAlphabetically = [];

    programsSortedAlphabetically = waitlistIDs.map((id, i) => {
      const {
        id: waitlistProgramId,
        directory_program: { name: programName, directory_school_name: schoolName },
        priority_group_text: priorityGroup,
        waitlist_information: waitlistInformation,
        two_k_start_date: twoKStartDate,
        waitlist_position: waitlistPosition,
        show_sibling_question: showSiblingQuestion
      } = waitlistData[id];
      return {
        programName,
        schoolName,
        id,
        priorityGroup,
        waitlistInformation,
        twoKStartDate,
        waitlistPosition,
        waitlistProgramId,
        // getting it from parallel array which is the only one that gets updated after submitting answers:
        additionalQuestions: pendingWaitlistPrograms[i]?.additional_questions,
        showSiblingQuestion,
      };
    });

    programsSortedAlphabetically.sort((a, b) => a.schoolName.localeCompare(b.schoolName));
    const programList = programsSortedAlphabetically.map((offer) => {
      const {
        id,
        programName,
        schoolName,
        priorityGroup,
        waitlistInformation,
        waitlistPosition,
        waitlistProgramId,
        additionalQuestions,
        showSiblingQuestion
      } = offer;
      const unansweredQuestions = additionalQuestions ? additionalQuestions.filter(({ answers }) => answers === null) : [];

      /* showSiblingsQuestionsForm -> This variable is responsible for enabling or disabling sigling information
        question. Make sure to check this variable to all files before adding support for new admission process.
      */
      const showSiblingsQuestionsForm = user.is2K || user.is3K || user.isPK || user.isK || user.isGTAPP || user.isMS ;
      const showAdditionalQuestions = user.is2K || user.is3K || user.isPK || user.isK || user.isGTAPP || isMS({ user });

      return (
        <li key={`${id}-school-waitlistDatasaved-program`} className={style.listItem} style={{ marginBottom: '20px' }}>
          <WaitlistCard
            key={id}
            title={schoolName}
            subtitle={programName}
            waitlistPosition={waitlistPosition}
            priorityGroup={priorityGroup}
            waitlistInformation={waitlistInformation}
            showWaitlistInfo={!user.isK}
            handleOnClick={() =>
              this.showAlertModal(
                [`${schoolName}'s ${programName}`],
                id,
                waitlistProgramId,
                'showRemoveWaitlistAlertModal',
              )
            }
            waitlistId={waitlistProgramId}
            handleQuestionsClick={this.showQuestionsPopUp}
            hasUnansweredQuestions={unansweredQuestions.length > 0}
            loading={user.loading}
            isAdditionalQuestionRequired={showAdditionalQuestions}
            disabled={!canAddRemoveWaitlist}
            showWaitlistPriorityGroupAndPosition={showWaitlistPriorityGroupAndPosition}
            showSiblingQuestion={showSiblingQuestion}
            showSiblingsQuestionsForm={showSiblingsQuestionsForm}
          />
        </li>
      );
    });

    return (
      <div>
        {programList}
        {load}
        {canAddRemoveWaitlist && (
          <div className={`${style.searchField} ${this.props.user.isDR && this.props.autocomplete.savedPrograms.length == 0 ? style.hideSearchFieldDR: '' }`}>
            <AutocompleteField
              onChangeValue={this.handleKeyDown}
              title="Other Programs"
              saveApplication={this.handleSaveApplication}
              options={this.props.autocomplete.savedPrograms}
              onBlur={() => { }}
              user={this.props.user}
            />
          </div>
        )}
      </div>
    );
  };

  renderWaitlists = () => {
    const {
      intl,
      user: {
        applicationId,
        firstName,
        studentWaitlists: { results },
      },
    } = this.props;
    const { currentSchoolDetail, loaded } = this.state;
    const joinedWaitlistProgramsCount = results.length;
    const displayNoJoinedWaitlistMessage = loaded && joinedWaitlistProgramsCount === 0;
    const noJoinedWaitlistSearchMsg = this.props.user.isDR ? localMessages.noJoinedWaitlistSearchDream : localMessages.noJoinedWaitlistSearch;
    const waitlistSubHeaderMsg = this.props.user.isDR ? localMessages.waitlistSubHeaderDream : localMessages.waitlistSubHeader;
    const pathSearch = `/dashboard/${applicationId}/schools/`;
    const showDRMessage =  this.props.user.isDR && this.props.autocomplete.savedPrograms.length == 0 ? false : true;
    const overviewLink = (
      <a href={`/${window.App.lang}/dashboard/${applicationId}/`} style={{ color: 'white' }}>
        <FormattedMessage  {...localMessages.waitlistOverview} />
      </a>
    );
    const searchingLink = <a href={pathSearch}>searching</a>;

    return (
      <div className={style.sidebar}>
        <FormattedMessage
          defaultMessage="{firstName}'s Waitlists"
          values={{ firstName }}
          id="waitlist.header"
          tagName="h1"
        />
        {showDRMessage && displayNoJoinedWaitlistMessage && (
          <div className={style.alertBox}>
            <span className={style.alertBoxText}>
              <FormattedMessage
                {...noJoinedWaitlistSearchMsg}
                values={{
                  searching: searchingLink,
                }}
                className={style.alertBox}
              />
            </span>
          </div>
        )}
        <div className={style.offerAcceptanceAlertBox}>
            <span className={style.alertBoxText}>
              <FormattedMessage
                {...localMessages.waitlistOfferAcceptance}
                values={{
                  searching: searchingLink,
                }}
                className={style.alertBox}
              />
            </span>
        </div>
        {this.props.user.twok_24_months_start_date_waitlist_message && <span className={style.alertBoxText}>
          <div className={style.alertBox} dangerouslySetInnerHTML={{ __html: this.props.user.twok_24_months_start_date_waitlist_message }}></div>
        </span>}
        <div>
        {!displayNoJoinedWaitlistMessage && (
          <div className={style.subHeaderWhite}>
            <p>
              <FormattedMessage
                {...waitlistSubHeaderMsg}
                values={{
                  Overview: overviewLink,
                }}
              />
            </p>
          </div>
        )}
          <div className="backToListScrollTarget" />
          {currentSchoolDetail && (
            <Button
              onClick={this.backToList}
              iconLeft="arrow-left"
              aria-label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
              label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
              iconColor="#4ee4b3"
              full
              large
            />
          )}
          <div className={style.schools}>{this.renderSchools()}</div>
        </div>
      </div>
    );
  };

  addToWaitlist = ({ programId, schoolId }) => {
    this.setState({...this.state}); // Calling to re render the UI so that StatusCard get refreshed
    this.props.joinWaitlist(programId, schoolId, true);
  };

  saveAnswers = (waitlistId, answers) => {
    this.props.saveAdditionalQuestionsAnswers(waitlistId, answers);
    this.setState({ ...this.state, showQuestions: false, waitlistId: 0 });
  };

  renderAlertModals = () => {
    const {
      showRemoveWaitlistAlertModal,
      showAcceptWaitlistAlertModal,
      showDeclineWaitlistAlertModal,
      schoolName,
    } = this.state;
    const removeWaitlistModalVisibility = classNames(style.modalContainer, {
      [style.modalContainerDisplay]: showRemoveWaitlistAlertModal,
    });
    const acceptWaitlistModalVisibility = classNames(style.modalContainer, {
      [style.modalContainerDisplay]: showAcceptWaitlistAlertModal,
    });
    const declineWaitlistModalVisibility = classNames(style.modalContainer, {
      [style.modalContainerDisplay]: showDeclineWaitlistAlertModal,
    });

    const { intl, user } = this.props;

    return (
      <>
        <div className={removeWaitlistModalVisibility}>
          <AlertModal
            title={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalRemoveTitleText)}
            subtitle={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalRemoveSubTitleText)}
            schoolName={schoolName}
            subNote={''}
            acceptButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalRemoveButtonText)}
            cancelButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalCancelButtonText)}
            handleAcceptClick={this.handleRemoveWaitlistCard}
            handleCancelClick={() => this.hideAlertModal('showRemoveWaitlistAlertModal')}
          />
        </div>
        <div className={acceptWaitlistModalVisibility}>
          <AlertModal
            title={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalAcceptTitleText)}
            subtitle={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalAcceptSubTitleText)}
            schoolName={schoolName}
            subNote={''}
            acceptButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalAcceptButtonText)}
            cancelButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalCancelButtonText)}
            handleAcceptClick={() => this.handleOfferStatusUpdate(true)}
            handleCancelClick={() => this.hideAlertModal('showAcceptWaitlistAlertModal')}
          />
        </div>
        <div className={classNames(style.modalContainer, { [style.modalContainerDisplay]: this.state.show2KAcceptWarningModal })}>
          <AlertModal
            title={customisedIntlFormatMessage(intl, { id: 'shsatresult.shsatNextStep' })}
            subtitle={''}
            schoolName={[]}
            subNote={''}
            message={this.state.pendingAcceptPayload?.warningMessage || customisedIntlFormatMessage(intl, localMessages.waitlistAlertModal2KAcceptMessageText)}
            acceptButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModal2KAcceptButtonText)}
            cancelButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalCancelButtonText)}
            handleAcceptClick={this.handle2KAcceptWarningConfirm}
            handleCancelClick={this.hide2KAcceptWarningModal}
          />
        </div>
        <div className={declineWaitlistModalVisibility}>
          <AlertModal
            title={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalDeclineTitleText)}
            subtitle={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalDeclineSubTitleText)}
            schoolName={schoolName}
            subNote={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalDeclineSubNoteText)}
            acceptButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalDeclineButtonText)}
            cancelButtonText={customisedIntlFormatMessage(intl, localMessages.waitlistAlertModalCancelButtonText)}
            handleAcceptClick={() => this.handleOfferStatusUpdate(false)}
            handleCancelClick={() => this.hideAlertModal('showDeclineWaitlistAlertModal')}
          />
        </div>
      </>
    );
  };

  render() {
    // replace the applicationLightbox to be present here instead of
    // in `renderPrograms` so it's visible on mobile
    const { mobileRender, loaded, showQuestions, waitlistId, programId } = this.state;
    const { pendingWaitlistPrograms, intl, user } = this.props;
    const programIndex = pendingWaitlistPrograms.findIndex(({ id }) => id === waitlistId);
    const showSiblingsQuestionsForm = user.is2K || user.is3K || user.isPK || user.isK || user.isMS || user.isGTAPP;
    if (!loaded) {
      return <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    }

    return (
      <main className={style.root} role="presentation">
        <div className={style.wrapper}>
          <div className={style.container}>
            {this.renderMobileButtons()}
            <div className={style.main}>
              <ApplyMobile>
                {this.mobileRenderMapping[mobileRender]()}
                {this.renderAlertModals()}
                {showQuestions && (
                  <QuestionsPopUp
                    handleCancelClick={this.hideQuestionsPopUp}
                    additionalQuestions={pendingWaitlistPrograms[programIndex].additional_questions}
                    saveAnswers={this.saveAnswers}
                    schoolName={pendingWaitlistPrograms[programIndex].directory_program['directory_school_name']}
                    schoolId={pendingWaitlistPrograms[programIndex].directory_program['directory_school_id']}
                    grades={pendingWaitlistPrograms[programIndex].grades}
                    waitListId={pendingWaitlistPrograms[programIndex].id}
                    showSiblingsQuestionsForm={showSiblingsQuestionsForm}
                    endYear={pendingWaitlistPrograms[programIndex].end_year}
                    showSiblingQuestion={pendingWaitlistPrograms[programIndex].show_sibling_question}
                    SiblingInfo={pendingWaitlistPrograms[programIndex].sibling_info}
                    user={user}
                  />
                )}
                {this.state.showSRQuestions && (
                  <SRQuestionsPopUp
                    {...this.props}
                    handleCancelClick={this.hideSRQuestionsPopUp}
                    user={user}
                    saveSRAnswers={this.saveSRAnswers}
                    isEdit={this.state.isEdit}
                    waitListId={waitlistId}
                    programId={programId}
                  />
                )}
              </ApplyMobile>
              <ApplyDefault>
                {this.renderAlertModals()}
                {this.renderWaitlists()}
                {showQuestions && (
                  <QuestionsPopUp
                    handleCancelClick={this.hideQuestionsPopUp}
                    additionalQuestions={pendingWaitlistPrograms[programIndex].additional_questions}
                    saveAnswers={this.saveAnswers}
                    schoolName={pendingWaitlistPrograms[programIndex].directory_program['directory_school_name']}
                    schoolId={pendingWaitlistPrograms[programIndex].directory_program['directory_school_id']}
                    grades={pendingWaitlistPrograms[programIndex].grades}
                    waitListId={pendingWaitlistPrograms[programIndex].id}
                    showSiblingsQuestionsForm={showSiblingsQuestionsForm}
                    endYear={pendingWaitlistPrograms[programIndex].end_year}
                    showSiblingQuestion={pendingWaitlistPrograms[programIndex].show_sibling_question}
                    SiblingInfo={pendingWaitlistPrograms[programIndex].sibling_info}
                    user={user}
                  />
                )}
                {this.state.showSRQuestions && (
                  <SRQuestionsPopUp
                    {...this.props}
                    handleCancelClick={this.hideSRQuestionsPopUp}
                    user={user}
                    saveSRAnswers={this.saveSRAnswers}
                    isEdit={this.state.isEdit}
                    waitListId={waitlistId}
                    programId={programId}
                  />
                )}
                <section className={style.applicationWrapper}>{this.renderPrograms()}</section>
              </ApplyDefault>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = ({ schools, schoolsApplications, filters, user, popup }) => ({
  ...schools,
  schoolsApplications,
  user,
  ...filters,
  popup,
});

const mapDispatchToProps = {
  joinWaitlist,
  removeFromWaitlist,
  handleOfferDecision,
  saveProgram,
  saveAdditionalQuestionsAnswers,
};

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps, mapDispatchToProps),
)(Waitlist);
